import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["controls", "poster"]
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Your browser does not support the video tag. ")
const _hoisted_4 = {
  key: 0,
  class: "video-player__play-container"
}

import { ref, computed } from "vue";


import { defineComponent } from 'vue';

const __default__ = defineComponent({
  name: 'VideoPlayer'
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  block: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props



const paused = ref(true);
const video = computed(() => props.block.video?.filename);
const poster = computed(() => props.block.poster?.filename);
const videoElement = ref(null);
const fullControls = computed(() => props.block?.videoControls);
const maxWidthStyle = computed(() => {
  return props.block?.maxWidth ? `max-width: ${props.block.maxWidth}` : '';
});

function playPause() {
  if (fullControls.value) {
    return;
  }

  if (paused.value) {
    videoElement?.value.play();
    paused.value = false;
  } else {
    videoElement?.value.pause();
    paused.value = true;
  }
}

function updatePaused(event) {
  paused.value = event.target.paused;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "video-player",
    onClick: playPause,
    style: _normalizeStyle(_unref(maxWidthStyle))
  }, [
    _createElementVNode("video", {
      ref_key: "videoElement",
      ref: videoElement,
      class: "video-player__video",
      playsinline: "",
      controls: _unref(fullControls),
      poster: _unref(poster),
      onCanplay: updatePaused,
      onPlaying: updatePaused,
      onPause: updatePaused
    }, [
      _createElementVNode("source", {
        src: _unref(video),
        type: "video/mp4"
      }, null, 8, _hoisted_2),
      _hoisted_3
    ], 40, _hoisted_1),
    (!_unref(fullControls))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["video-player__play", { 'video-player__play-hidden': !paused.value }])
          }, null, 2)
        ]))
      : _createCommentVNode("", true)
  ], 4))
}
}

})